// Single source of truth for "does this deal count toward this agent on the
// roster?"
//
// The rule (per Henry):
//   - In-house referral → the team lead of record gets the credit.
//   - Anything else     → the agent on the deal gets the credit.
//   - No agent set      → fall back to the team lead.
//
// Use this everywhere the team roster sums up deal-count, volume, or
// per-agent stats so we don't double-count when a deal has both an
// agentData and an assignedteamlead.

export function dealCreditsAgent(deal, agentId) {
  if (!deal || !agentId) return false;
  const isInhouseReferral = !!deal.inhousereferral;
  if (isInhouseReferral) {
    return deal.assignedteamlead === agentId;
  }
  if (deal.agentData) {
    return deal.agentData === agentId;
  }
  return deal.assignedteamlead === agentId;
}

// Cancelled and expired deals shouldn't show up in deal-count, volume, or
// commission totals — they're dead. Use this anywhere you sum or count deals
// for performance metrics.
export function isCountableDeal(deal) {
  const stage = (deal?.dealStage || "").toLowerCase();
  return stage !== "cancelled" && stage !== "expired";
}
